export default __webpack_public_path__ + "static/media/seven.55fe9e4a.png";